import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-10 md:py-16 px-3 bg-brand-bordo" data-id="element-114">
      <div className="max-w-3xl mx-auto text-center" data-id="element-115">
        <div className="inline-flex items-center justify-center w-20 h-20 bg-brand-accent rounded-2xl mb-6 shadow-[0_0_30px_rgba(234,179,8,0.4)] transform rotate-3" data-id="element-116">
          <ShieldCheck className="w-12 h-12 text-black" data-id="element-117" />
        </div>

        <h2 className="text-2xl md:text-4xl font-black mb-6 text-white uppercase text-shadow-lg" data-id="element-118">
          🛡️ GARANTÍA 7 DÍAS — SIN PREGUNTAS
        </h2>

        <div className="text-lg md:text-xl font-bold space-y-3 mb-8 text-gray-200" data-id="element-119">
          <p data-id="element-120">Abrís los tomos. Los usás en el taller.</p>
          <p data-id="element-121">Si en 7 días no es lo que esperabas:</p>
          <div className="flex flex-col items-center justify-center gap-3 mt-6" data-id="element-122">
            <p className="text-xl md:text-2xl font-black text-brand-accent bg-black px-6 py-3 rounded-xl border-2 border-brand-accent/50 w-full max-w-md uppercase shadow-lg" data-id="element-123">
              👉 Devolución del 100%
            </p>
            <p className="text-xl md:text-2xl font-black text-brand-accent bg-black px-6 py-3 rounded-xl border-2 border-brand-accent/50 w-full max-w-md uppercase shadow-lg" data-id="element-124">
              👉 Sin formularios
            </p>
            <p className="text-xl md:text-2xl font-black text-brand-accent bg-black px-6 py-3 rounded-xl border-2 border-brand-accent/50 w-full max-w-md uppercase shadow-lg" data-id="element-125">
              👉 Sin vueltas
            </p>
          </div>
        </div>

        <p className="text-sm md:text-base text-black font-black bg-brand-accent inline-block px-6 py-2 rounded-full uppercase tracking-widest shadow-md" data-id="element-126">
          Tasa de devoluciones: menos del 1%
        </p>
      </div>
    </section>;
}